import React from 'react';
import { ChevronIcon } from '../../../svgIcons';
import { Breadcrumb, BreadcrumbProps } from '../Breadcrumb/Breadcrumb';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- auto-generated TECH-258
interface Props extends BreadcrumbProps {}

export const BreadcrumbWithChevron: React.FC<Props> = (props) => {
  return (
    <>
      <Breadcrumb {...props} />
      <ChevronIcon className="margin-left-4 margin-right-4 explorer-breadcrumbs__chevron-icon" />
    </>
  );
};
